import reducer from './reducer'
export { default as operations } from './operations'
export { default as selectors } from './selectors'

export default reducer
